import { Layout } from '../layout';

import GoBackLink from '../goBackLink/GoBackLink';
import { HeaderDisplay } from '../headerDisplay';

import { useTranslation } from 'react-i18next';
import { useRoles } from '../../contexts/RolesContext';
import { useSmSheet } from '../../hooks/useSmSheet';
import { ErrorPage } from '../errorPage';
import { SmMainInfos } from '../smMainInfos';
import { SmOfferInfos } from '../smOfferInfos/SmOfferInfos';
import { SmQuickInfos } from '../smQuickInfos';
import { SmSalesInfos } from '../smSalesInfos';
import { SmSport } from '../smSport';
import { SmTeamMembers } from '../smTeamMembers';
import './mySm.scss';

export const MySM = () => {
  const params = new URLSearchParams(document.location.search);
  const smId = params.get('id');
  const offerDate = params.get('offerDate');
  const { t } = useTranslation();

  const { hasRoleVisualization } = useRoles();

  const { data: smSheetData, isFetching } = useSmSheet(
    smId as string,
    offerDate as string,
  );

  return (
    <Layout>
      <div className="my-sm-container">
        {hasRoleVisualization ? (
          <>
            <HeaderDisplay />
            <div data-testid="my-sm">
              <GoBackLink path="/personal-offer/my-view" />
              <div className="my-sm-header">
                <SmQuickInfos sm={smSheetData} isLoading={isFetching} />
              </div>
              <SmMainInfos isLoading={isFetching} sm={smSheetData} />
              <SmSport sm={smSheetData} isLoading={isFetching} />
              <SmOfferInfos sm={smSheetData} />
              <SmSalesInfos sm={smSheetData} isLoading={isFetching} />
              <SmTeamMembers sm={smSheetData} />
            </div>
          </>
        ) : (
          <ErrorPage
            errorPageTitle={t('no-access-page.title')}
            errorMessage={t('no-access-page.subtitle')}
          />
        )}
      </div>
    </Layout>
  );
};
